<template>
  <div>
    <HeaderCont />
    <TitleCont name1="About" name2="Me" />
    <section className="cont__about">
      <div className="container">
        <div className="about__inner">
          <div className="about__in1">
            <img
              src="https://images.unsplash.com/photo-1461896836934-ffe607ba8211?ixlib=rb-4.0.3&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=1770&amp;q=80"
              alt="마라톤"
            />
            <h2>"인생은 마라톤이다."</h2>
            <p>
              인생은 사람이 태어나서 죽기까지의 과정 속에서 희노애락이 모두 담긴
              한편의 드라마입니다.
              <br />
              <br />
              마라톤 역시 오랫동안 달리면서 인간이 느낄 수 있는 많은 감정들을
              느끼며 완주를 위해 결코 포기하지 않고 계속 나아가는 것이 인간의
              인생사처럼 느껴졌습니다.
              <br />
              <br />
              어릴 적 육상 선수로 장거리 달리기를 뛴 적이 있습니다. 처음에
              페이스를 조절하여 완주를 위한 계획을 짜고 자신하지만 시간이 지나고
              끝을 향해 갈수록 심박수는 요동치며 작은 고통도 크게 느껴지게
              됩니다. 이 때 자신과의 타협이 시작됩니다. '힘든데 멈출까?',
              '다음에 잘하면 되지' 등의 안일한 생각의 유혹에 쉽게 휩싸일 수
              있습니다. 그러나 의지력이 강한 사람은 이런 유혹들을 참아내고
              끝까지 완주하여 성취감을 맛보게 됩니다. 포기 혹은 멈추는 순간
              패배자가 됩니다. 고로 저는 처음부터 적절한 페이스를 유지하되 내가
              치고 나갈 수 있는 부분에서는 적극적으로 나서며 결국 좋은 성과를
              얻을 수 있었습니다.
              <br />
              <br />
              인생 역시 마찬가지입니다. 장거리 달리기, 마라톤과 같이 적절한
              페이스를 유지하며 포기하지 않고 계속해서 나아간다면 보다 나은
              인생과 함께 목표한 바를 이룰 수 있으리라 생각합니다.
            </p>
          </div>
          <div className="about__in2">
            <img
              src="https://images.unsplash.com/photo-1545315003-c5ad6226c272?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80"
              alt=""
            />
            <h2>"피할 수 없으면 즐겨라."</h2>
            <p>
              피할 수 없다면 즐겨라.
              <br />
              <br />
              우리는 인생에서 그저 즐겁고 기쁜 순간만 반복되는 것이 아니라, 정말
              싫고 괴롭지만 어쩔 수 없이 감내해야 하는 상황에 자주 마주치기도
              합니다. 영양상으로 균형 잡힌 식단을 먹기 위해서는 단맛에만 치중한
              형태가 아니라, 짠맛과 신맛, 쓴맛 등을 적절히 배분해 섭취할 줄
              알아야 하는 것처럼 말입니다. 인내는 쓰지만, 그 열매는 달다는 말이
              있듯이, 그와 같은 고난이 있기에 보상처럼 찾아오는 단맛이 더욱
              매혹적으로 느껴지기도 합니다.
              <br />
              <br />
              우리는 그와 같은 위기를 그저 어쩔 수 없이 받아들여야 하는,
              인생에서 무한하게 반복되는 굴레처럼 여기는 것이 아니라, 나를 더욱
              단련시키고 세상 풍파에 흔들리지 않는 담금질로 제련해주는 단계의
              하나로 인식해야 합니다. 육체의 고통에 더해 정신적 고통까지
              얹어지게 된다면, 우리는 인생의 많은 시간을 그저 ‘빨리 감아버리고
              싶은 시간’들로 낭비하게 되기 때문입니다. 우리가 삶을 살아가기
              위해서는 절대 달아날 수 없고, 어차피 반복하여 감내해야 하는 시간
              일부분이라면, 차라리 그것을 최대한 즐길 발상의 전환을 고안해,
              시간의 낭비를 막는 것 또한 인생을 즐기는 시도가 되리라고
              생각합니다.
            </p>
          </div>
          <div className="about__in3">
            <img
              src="https://images.unsplash.com/photo-1484100356142-db6ab6244067?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fGxpZmV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
              alt=""
            />
            <h2>"변화하는 세상을 언제나 놀랍고 신선하게 받아들이자."</h2>
            <p>
              변화하는 세상을 언제나 놀랍고 신선하게 받아들이자.
              <br />
              <br />
              우리는 매일의 똑같은 일상이 반복될 뿐이라고 삶을 따분하게 여기는
              경우가 많지만, 우리가 지금껏 지나쳐온 매일의 어떤 순간도 완벽하게
              같은 상황은 없었습니다. 일과를 수행하는 도중에 발생한 시간적 오차
              혹은 날씨, 사회 현상, 온도나 습도, 우연히 만난 사람이나 TV로나
              간신히 접할 수 있었던 머나먼 세계의 갖가지 사건에 이르기까지,
              우리의 인생은 실로 다양한 조건의 조합으로 결코 완벽하게 들어맞지
              않는 가지각색의 일상을 펼쳐 보였던 것입니다.
              <br />
              <br />
              그것이 언뜻 어제 혹은 내일과 달라 보이지 않는다 해서, 인생에
              다분히 불성실한 태도로 임한다면, 우리는 그 세세한 차이가 주는
              기쁨과 두근거림을 제대로 받아들이지 못하고, 어떤 변화도 인지하지
              못한 채 서서히 노쇠해갈 수밖에 없는 것입니다. 세상은 충분히 변하고
              있고, 그저 모든 일상을 따분하게 바라보게끔 불투명한 막이 씌워진
              곳은 자신의 눈인데도 말입니다. <br />
              <br />
              우리가 세상의 미세한 변화조차 잡아내고자 하는 의지로, 더욱
              적극적인 인생을 살고자 노력한다면 우리는 더욱 다양한 인생의
              바리에이션을 만날 수 있으리라 생각합니다.
            </p>
          </div>
        </div>
      </div>
    </section>
    <ContactCont />
    <FooterCont />
  </div>
</template>

<script>
import HeaderCont from "@/components/HeaderCont.vue";
import TitleCont from "@/components/TitleCont.vue";
import FooterCont from "@/components/FooterCont.vue";
import ContactCont from "@/components/ContactCont.vue";

export default {
  components: {
    HeaderCont,
    TitleCont,
    FooterCont,
    ContactCont,
  },
};
</script>

<style lang="scss">
.about__inner {
  color: #000;
  font-family: var(--font-main);
  .about__in1 {
    > img {
      width: 70%;
    }
    > h2 {
      font-size: 36px;
      font-weight: bold;
      text-align: right;
      margin-top: 80px;
      margin-bottom: 30px;
    }
    > p {
      font-size: 18px;
      float: right;
      text-align: right;
      width: 65%;
      line-height: 2;
      word-break: keep-all;
      margin-bottom: 100px;
    }
  }
  .about__in2 {
    position: relative;

    > img {
      width: 65%;
      height: 500px;
      float: right;
    }
    > h2 {
      position: absolute;
      top: 950px;
      left: 0;
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 30px;
    }
    > p {
      font-size: 18px;
      float: left;
      text-align: left;
      width: 65%;
      line-height: 2;
      word-break: keep-all;
      margin-bottom: 100px;
    }
  }
  .about__in3 {
    > img {
      height: 500px;
    }
    > h2 {
      font-size: 36px;
      text-align: center;
      top: 950px;
      font-weight: bold;
      margin-bottom: 50px;
      margin-top: 50px;
    }
    > p {
      text-align: center;
      font-size: 18px;
      text-align: center;
      line-height: 1.7;
      word-break: keep-all;
    }
  }
}
</style>
